module.exports = __webpack_public_path__ + "rice_BG.449446a718309c9c7081.png";


//////////////////
// WEBPACK FOOTER
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/assets/img/rice_BG.png
// module id = ../../../../../src/assets/img/rice_BG.png
// module chunks = main styles